export class ModalUtils {
  private modalsText = {};
  constructor(public courseName?: string, public type?: string) {
    this.setModalsText();
  }

  private setModalsText(): void {
    this.modalsText = {
      sendToApprove: {
        message: {
          pt: `Você tem certeza que deseja enviar para aprovação o curso ${this.courseName}?`,
          en: `Are you sure you want to submit the ${this.courseName} course for approval?`,
        },
        header: `Enviar para aprovação`,
        acceptLabel: "Enviar",
        rejectLabel: "Não",
        rejectClass: "btn-outline",
        acceptClass: "btn-primary",
      },
      toApprove: {
        message: {
          pt: `Você tem certeza que deseja aprovar o curso ${this.courseName}? Assim que aprovado ele será publicado!`,
          en: `Are you sure you want to pass the ${this.courseName} course? Once approved it will be published!`,
        },
        header: `Aprovar ${this.courseName}`,
        acceptLabel: "Publicar",
        rejectLabel: "Cancelar",
        rejectClass: "btn-outline",
        acceptClass: "btn-primary",
      },
      toApproveTraditional: {
        message: {
          pt: `Informe abaixo como será exibido o curso para o aluno e depois clique em “Aprovar curso”, após isso o curso será publicado.`,
          en: `Enter below how the course will be displayed to the student and then click on “Approve course”, after which the course will be published.`,
        },
        header: `Alterar a exibição do curso “${this.courseName}”?`,
        acceptLabel: "Publicar",
        rejectLabel: "Cancelar",
        rejectClass: "btn-outline",
        acceptClass: "btn-primary",
      },
    };
  }

  getModalsText(type: string): any {
    return this.modalsText[type];
  }
}
